var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtDashboardOrganization = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.064%",
    x2: "99.965%",
    y2: "50.064%",
    id: "a5wb0jp81a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "-2429.606%",
    x2: "100%",
    y2: "-2429.606%",
    id: "s7g6ll1njb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-474.525%",
    y1: "50.064%",
    x2: "-471.074%",
    y2: "50.064%",
    id: "vlv34epvcc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.064%",
    x2: "100%",
    y2: "50.064%",
    id: "ov9tkc2uvd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "M10 14h16.814v41.962H10z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.067 36.728h1.77v2.206h-1.77zM17.956 32.053h1.77v2.156h-1.77zM17.956 36.728h1.77v2.206h-1.77zM12.827 32.053h1.77v2.156h-1.77zM12.827 36.728h1.77v2.206h-1.77z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.067 41.592h1.77v2.156h-1.77zM17.956 41.592h1.77v2.156h-1.77zM17.956 46.365h1.77v2.156h-1.77zM12.827 41.592h1.77v2.156h-1.77z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#64C0C3",
    d: "M22.363 32.171h15.991v23.79H22.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a5wb0jp81a)",
    d: "M0 0h3.395v1H0z",
    transform: "translate(23.585 34.035)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s7g6ll1njb)",
    d: "M7.363 0h3.475v1H7.363z",
    transform: "translate(23.585 34.035)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vlv34epvcc)",
    d: "M0 2.69h3.395v1H0z",
    transform: "translate(23.585 34.035)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ov9tkc2uvd)",
    d: "M7.363 2.69h3.475v1H7.363z",
    transform: "translate(23.585 34.035)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vlv34epvcc)",
    d: "M0 5.371h3.395v1H0z",
    transform: "translate(23.585 34.035)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ov9tkc2uvd)",
    d: "M7.363 5.371h3.475v1H7.363z",
    transform: "translate(23.585 34.035)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vlv34epvcc)",
    d: "M0 8.061h3.395v1H0z",
    transform: "translate(23.585 34.035)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ov9tkc2uvd)",
    d: "M7.363 8.061h3.475v1H7.363z",
    transform: "translate(23.585 34.035)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vlv34epvcc)",
    d: "M0 0h3.395v1H0z",
    transform: "translate(23.585 44.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ov9tkc2uvd)",
    d: "M7.363 0h3.475v1H7.363z",
    transform: "translate(23.585 44.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vlv34epvcc)",
    d: "M0 2.69h3.395v1H0z",
    transform: "translate(23.585 44.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ov9tkc2uvd)",
    d: "M7.363 2.69h3.475v1H7.363z",
    transform: "translate(23.585 44.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vlv34epvcc)",
    d: "M0 5.371h3.395v1H0z",
    transform: "translate(23.585 44.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ov9tkc2uvd)",
    d: "M7.363 5.371h3.475v1H7.363z",
    transform: "translate(23.585 44.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vlv34epvcc)",
    d: "M0 8.061h3.395v1H0z",
    transform: "translate(23.585 44.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ov9tkc2uvd)",
    d: "M7.363 8.061h3.475v1H7.363z",
    transform: "translate(23.585 44.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M35.533 16.437h14.513v39.526H35.533z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F6C760"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.37 44.32h10.838v1H37.37zM37.37 46.32h10.838v1H37.37zM37.37 48.31h10.838v1H37.37zM37.37 50.308h10.838v1H37.37z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#64C0C3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.37 19.579h3.395v1H37.37zM44.733 19.579h3.475v1h-3.475zM37.37 21.578h3.395v1H37.37zM44.733 21.578h3.475v1h-3.475zM37.37 23.568h3.395v1H37.37zM44.733 23.568h3.475v1h-3.475zM37.37 25.566h3.395v1H37.37zM44.733 25.566h3.475v1h-3.475z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#64C0C3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.37 27.537h3.395v1H37.37zM44.733 27.537h3.475v1h-3.475zM37.37 29.536h3.395v1H37.37zM44.733 29.536h3.475v1h-3.475zM37.37 31.526h3.395v1H37.37zM44.733 31.526h3.475v1h-3.475zM37.37 33.524h3.395v1H37.37zM44.733 33.524h3.475v1h-3.475z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AFD7C7",
    d: "M46.955 39.409H60V56H46.955z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F6C760"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.913 41.605h1.341v2.156h-1.34zM56.913 46.28h1.341v2.206h-1.34zM53.045 41.605h1.341v2.156h-1.34zM53.045 46.28h1.341v2.206h-1.34zM49.162 41.605h1.341v2.156h-1.34zM49.162 46.28h1.341v2.206h-1.34z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.913 51.145h1.341V53.3h-1.34zM49.162 51.145h1.341V53.3h-1.34z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.067 17.292h1.77v2.156h-1.77zM23.067 21.968h1.77v2.206h-1.77zM17.956 17.292h1.77v2.156h-1.77zM17.956 21.968h1.77v2.206h-1.77zM12.827 17.292h1.77v2.156h-1.77zM12.827 21.968h1.77v2.206h-1.77z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.067 26.832h1.77v2.156h-1.77zM17.956 26.832h1.77v2.156h-1.77zM12.827 26.832h1.77v2.156h-1.77z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtDashboardOrganization);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-dashboard-organization.390c796dbb4946e3dc10a1911cb3f81a.svg";